import { usePollWorkflows } from '@frontend/payments-hooks';
import { usePaymentPlanShallowStore } from '../../providers/payment-plans-provider';
import { usePaymentPlanDetails } from './use-payment-plan-details';

export const usePaymentPlanPollWorkflow = ({
  onComplete,
  onFailure,
  paymentPlanId,
}: {
  onComplete?: () => void;
  onFailure?: () => void;
  paymentPlanId: string;
}) => {
  const { refetchDetails, refetchHistory } = usePaymentPlanDetails({ paymentPlanId });
  const { workflowId, setWorkflowId } = usePaymentPlanShallowStore('workflowId', 'setWorkflowId');

  const { refetch, loading } = usePollWorkflows({
    workflowIds: workflowId ? [workflowId] : [],
    setWorkflowIds: () => setWorkflowId(null),
    onComplete,
    onFailure,
    refetch: async () => {
      try {
        await refetchDetails();
        await refetchHistory();
      } catch (err) {
        console.error('Error updating plan details');
      }
    },
  });

  return {
    refetchPlanDetails: refetch,
    loading,
  };
};
